let toggleRedemptionForm = () => {
    let redemptionForm = document.getElementById('redemption_form');
    let redemptionCta = document.getElementById('redemption_cta');

    redemptionForm.classList.toggle('d-none');
    redemptionCta.classList.toggle('d-none');
}

let verifyExperience = () => {
    let urlParams = new URLSearchParams(window.location.search);
    initExperience(!!urlParams.get('uid'))
}

let initExperience = (isSuccess) => {

    let redemptionSplash = document.getElementById('redemption_splash');
    let contentLoader = document.querySelector('.content-loader');
    let redeptionBody = document.querySelector('body');

    if (isSuccess) {
        contentLoader.classList.add('verified');

        setTimeout(() => {
            redeptionBody.classList.add('verified');
            redemptionSplash.classList.add('d-none');
        }, 1000);
        return;
    }
    document.querySelectorAll('.invalid-session').forEach(function(el) {
        el.style.display = 'block';
    });
    contentLoader.classList.add('not-verified');

    setTimeout(() => {
        redeptionBody.classList.add('not-verified');
    }, 1000);
}

let copyRedemptionCode = () => {
    let redemptionCodeField = document.getElementById('redemption_code');
    let tooltipParent = document.getElementById('copy_redemption_code');

    redemptionCodeField.select();
    navigator.clipboard.writeText(redemptionCodeField.value);

    let tooltip = new bootstrap.Tooltip(tooltipParent, {
        title: 'Copied!',
    })
    tooltip.show();
    tooltipParent.addEventListener('hidden.bs.tooltip', () => {
        tooltip.dispose();
    });
}


verifyExperience();

let redemptionForm = document.getElementById('redemption_form');
let redemptionFormError = document.getElementById('form_error');
let redemptionCodeField = document.getElementById('redemption_code');

// grab serialNumber from url params
let urlParams = new URLSearchParams(window.location.search);
let serialNumber = urlParams.get('uid');

// add submit event listener to redemptionForm
redemption_form.addEventListener('submit', (e) => {
    e.preventDefault();
    serial_number
    let payload = {
        "serial_number": serialNumber,
        "redemption_email": document.getElementById('redemption_email').value,
        "redemption_code": document.getElementById('mfa_code').value,
    };

    fetch('https://beans.secretlab.co/api/nfc/discount_code', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    }).then((response) => {
        return response.json();
    }).then((data) => {
        if (data.error) {
            // set redemptionFormError to data.msg and remove d-none
            redemptionFormError.innerText = data.msg;
            redemptionFormError.classList.remove('d-none');
            return;
        }
        // hide form and show success message
        redemptionCodeField.value = data.payload.discount_code;
        toggleRedemptionForm();
    });
});
